import React from 'react';

export default ({ children, id }) => (
  <p style={{ overflowX: 'hidden' }}> {/* TODO: replace with CSS class */}
    {children}
  </p>
)
